/* jshint esversion: 6, -W097 */
/* globals module */
"use strict";

SpecialOffersService.$inject = [
    '$q',
    '$log',
    '$filter',
    'CategoriesService',
    'CmsContentService',
    'RebatesService',
    'UtilService',
];
function SpecialOffersService(
    $q,
    $log,
    $filter,
    CategoriesService,
    CmsContentService,
    RebatesService,
    UtilService
) {
    return {
        getCategories
    };

    /**
     * Gets categories that are both rebatable and have checkout enabled.
     */
    function getInstantDiscountCategories() {
        return CategoriesService.getCategories().then(categories => {
            const filteredCategories = categories.filter(category => {
                return category.is_rebatable && category.is_checkout_enabled;
            });
            const setupPromises = [];
            filteredCategories.forEach(category => {
                setupPromises.push(_setupAdditionalCategoryInfo(category));
            });
            return $q.all(setupPromises);
        });
    }

    /**
     * Gets categories that are rebatable, but do not have checkout enabled.
     */
    function getRebatableCategories() {
        return CategoriesService.getCategories().then(categories => {
            const filteredCategories = categories.filter(category => {
                return category.is_rebatable && !category.is_checkout_enabled;
            });
            const setupPromises = [];
            filteredCategories.forEach(category => {
                setupPromises.push(_setupAdditionalCategoryInfo(category));
            });
            return $q.all(setupPromises);
        });
    }

    /**
     * Sets up additional information for the given category.
     * @param {*} category 
     */
    function _setupAdditionalCategoryInfo(category) {
        return _getMaxRebate(category).then(category => {
            category = _setCategoryImage(category);
            return category;
        });
    }

    /**
     * Gets the default category image and icon name for the given category 
     * for display.
     * @param {*} category 
     */
    function _setCategoryImage(category) {
        category.defaultImage = CategoriesService.getCategoryImage(category);
        category.icon_name = category.name.toLowerCase().replace(/ /g, '-');
        return category;
    }

    /**
     * Gets the max available rebate for the given category, then sets up
     * business rules.
     * @param {*} category 
     */
    function _getMaxRebate(category) {
        return RebatesService.getMaxRebatesForCategory(category.category_code).then(data => {
            category.maxRebate = !!parseFloat(data) ? parseFloat(data) : null;
            return _getBusinessRuleTexts(category).then(texts => {
                category.businessRuleTexts = texts.filter(text => text.length);
                return category;
            });
        }, function (error) {
            $log.warn(error);
            category.maxRebate = null;
            category.businessRuleTexts = [];
            return category;
        });
    }

    /**
     * Gets the business rule category setting if it exists, then gets
     * corresponding CMS Marketplace Texts for the business rules.
     * @param {*} category 
     */
    function _getBusinessRuleTexts(category) {
        const rules = UtilService.getCategorySetting(category.id, 'business_rules', []);
        const cmsPromises = [];
        rules.forEach(rule => {
            if (category.maxRebate) {
                rule['amount'] = $filter('toCurrency')(category.maxRebate);
            }
            let promise = CmsContentService.getMarketPlaceText(
                `special_offers:business_rules_${rule.rule_type.toLowerCase()}`,
                rule,
                category.id
            );
            cmsPromises.push(promise);
        });

        return $q.all(cmsPromises);
    }

    /**
     * Returns promises for the category lists needed for display.
     */
    function getCategories() {
        const categoryPromises = [
            getInstantDiscountCategories(),
            getRebatableCategories()
        ];
    
        return $q.all(categoryPromises);
    }
}

module.exports = SpecialOffersService;